var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-flex items-center mr-3 my-2 px-3 py-1 rounded-md text-xs font-medium leading-normal bg-secondary-gray shadow-sm text-primary-black"},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }